import { palette } from '../../../styles/variables'

export const pricingPage = {
  commonPromoBackground: '#082F46',
  promotionText: 'bf_pricing_page_heading',
  radioGroupPromoText: 'holiday_offer',
  showRadioGroupPromoSearchIcon: false,
  promoBadgeColor: palette.white,
  promoBadgeBackground:
    'linear-gradient(90deg, #F13D56 0%, #DC1B36 10%, #DC1B36 90%, #F13D56 100%)',
  promoBadgeText: 'holiday_offer',
  yearlyPriceColor: palette.darkGray70,
}
